import 'Shared/mootools';
import 'shared-constants';
import 'Shared/global';
import 'Guide/guide_constants.js.php';
import 'Guide/Header/LanguageDropdown/language_dropdown_button';
import 'Guide/footer';
import 'Shared/ifixit-header-footer';
import Loader from 'Shared/utils/loader';

// Initialize navigation event listeners
Loader.initNavEvents();
